import { Grid } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { skillsEvaluation } from 'src/services';
import { useParams } from 'react-router-dom';
import { CURRENT_USER } from 'src/constants';
import { User } from 'src/models/user/user.model';
import { EaSkillData } from 'src/models/skill/skill.model';
import AccordionEvaluationCompetenceItem from '../../../FicheEA/PreparationEA/EvaluationCompetence/AccordionEvaluationCompetenceItem';
import CompetenceBM from './CompetenceBM';
import { BusinessManagerContext } from 'src/contexts/BusinessManagerContext';
import ASMAlert from 'src/components/Alert';
import SuspenseLoader from 'src/components/SuspenseLoader';

function EvaluationCompetenceBM(props) {
    const { t, i18n } = useTranslation();
    const { REACT_APP_NOTIFICATION_DURATION } = process.env;
    const {
        setBDSkillsDataContext,
        setSCSkillsDataContext,
        setRCSkillsDataContext,
        setMHSkillsDataContext,
        setGCSkillsDataContext,
        setPOSkillsDataContext,
        setBMSkillsDataContext,
        setCMSkillsDataContext,
        setEPSkillsDataContext,
        showBDSkills,
        setShowBDSkillsContext,
        showSCSkills,
        setShowSCSkillsContext,
        showRCSkills,
        setShowRCSkillsContext,
        showMHSkills,
        setShowMHSkillsContext,
        showGCSkills,
        setShowGCSkillsContext,
        showPOSkills,
        setShowPOSkillsContext,
        showBMSkills,
        setShowBMSkillsContext,
        showCMSkills,
        setShowCMSkillsContext,
        showEPSkills,
        setShowEPSkillsContext
    } = useContext(BusinessManagerContext);
    const params = useParams();
    const [displayAlertError, setDisplayAlertError] = useState<boolean>(false);
    const [loading, setLoading] = useState(false);
    const userData: User = JSON.parse(localStorage.getItem(CURRENT_USER));
    const [BDSkills, setBDSkills] = useState<EaSkillData[]>([]);
    const [SCSkills, setSCSkills] = useState<EaSkillData[]>([]);
    const [RCSkills, setRCSkills] = useState<EaSkillData[]>([]);
    const [MHSkills, setMHSkills] = useState<EaSkillData[]>([]);
    const [GCSkills, setGCSkills] = useState<EaSkillData[]>([]);
    const [POSkills, setPOSkills] = useState<EaSkillData[]>([]);
    const [BMSkills, setBMSkills] = useState<EaSkillData[]>([]);
    const [CMSkills, setCMSkills] = useState<EaSkillData[]>([]);
    const [EPSkills, setEPSkills] = useState<EaSkillData[]>([]);
    const idBusinessManager = props.idBusinessManager;
    let request = {
        idUser: userData.id,
        year: params.year,
        idLang: i18n.language === 'fr' ? 1 : 2
    };
    if (params.id != undefined) {
        request = {
            idUser: parseInt(params.id),
            year: params.year,
            idLang: i18n.language === 'fr' ? 1 : 2
        };
    }
    // get each data
    // BDSkills
    const [openBDSkills, setOpenBDSkills] = useState<boolean>(false);
    const onChangeAccordionBDSkills = () => {
        setLoading(true)
        setOpenBDSkills(true)
        setShowBDSkillsContext(true)
        setLoading(false)
    }
    useEffect(() => {
        if (idBusinessManager != 0) {
            setLoading(true)
            skillsEvaluation.getEaSkillData(request, 6).then(response => {
                if (response.data.success) {
                    if (response.data.data != null) {
                        setBDSkills(response.data.data)
                    }
                } else {
                    setDisplayAlertError(true)
                    setTimeout(() => {
                        setDisplayAlertError(false);
                    }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
                }
            }).catch(err => {
                setDisplayAlertError(true)
                setTimeout(() => {
                    setDisplayAlertError(false);
                }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
            }).finally(() => {
                setLoading(false)
            });
        }
    }, [openBDSkills]);
    // SCSkills
    const [openSCSkills, setOpenSCSkills] = useState<boolean>(false);
    const onChangeAccordionSCSkills = () => {
        setLoading(true)
        setOpenSCSkills(true)
        setShowSCSkillsContext(true)
        setLoading(false)
    }
    useEffect(() => {
        if (idBusinessManager != 0) {
            setLoading(true)
            skillsEvaluation.getEaSkillData(request, 7).then(response => {
                if (response.data.success) {
                    if (response.data.data != null) {
                        setSCSkills(response.data.data)
                    }
                } else {
                    setDisplayAlertError(true)
                    setTimeout(() => {
                        setDisplayAlertError(false);
                    }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
                }
            }).catch(err => {
                setDisplayAlertError(true)
                setTimeout(() => {
                    setDisplayAlertError(false);
                }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
            }).finally(() => {
                setLoading(false)
            });
        }
    }, [openSCSkills]);
    // RCSkills
    const [openRCSkills, setOpenRCSkills] = useState<boolean>(false);
    const onChangeAccordionRCSkills = () => {
        setLoading(true)
        setOpenRCSkills(true)
        setShowRCSkillsContext(true)
        setLoading(false)
    }
    useEffect(() => {
        if (idBusinessManager != 0) {
            setLoading(true)
            skillsEvaluation.getEaSkillData(request, 8).then(response => {
                if (response.data.success) {
                    if (response.data.data != null) {
                        setRCSkills(response.data.data)
                    }
                } else {
                    setDisplayAlertError(true)
                    setTimeout(() => {
                        setDisplayAlertError(false);
                    }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
                }
            }).catch(err => {
                setDisplayAlertError(true)
                setTimeout(() => {
                    setDisplayAlertError(false);
                }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
            }).finally(() => {
                setLoading(false)
            });
        }
    }, [openRCSkills]);
    // MHSkills
    const [openMHSkills, setOpenMHSkills] = useState<boolean>(false);
    const onChangeAccordionMHSkills = () => {
        setLoading(true)
        setOpenMHSkills(true)
        setShowMHSkillsContext(true)
        setLoading(false)
    }
    useEffect(() => {
        if (idBusinessManager != 0) {
            setLoading(true)
            skillsEvaluation.getEaSkillData(request, 9).then(response => {
                if (response.data.success) {
                    if (response.data.data != null) {
                        setMHSkills(response.data.data)
                    }
                } else {
                    setDisplayAlertError(true)
                    setTimeout(() => {
                        setDisplayAlertError(false);
                    }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
                }
            }).catch(err => {
                setDisplayAlertError(true)
                setTimeout(() => {
                    setDisplayAlertError(false);
                }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
            }).finally(() => {
                setLoading(false)
            });
        }
    }, [openMHSkills]);
    // GCSkills
    const [openGCSkills, setOpenGCSkills] = useState<boolean>(false);
    const onChangeAccordionGCSkills = () => {
        setLoading(true)
        setOpenGCSkills(true)
        setShowGCSkillsContext(true)
        setLoading(false)
    }
    useEffect(() => {
        if (idBusinessManager != 0) {
            setLoading(true)
            skillsEvaluation.getEaSkillData(request, 10).then(response => {
                if (response.data.success) {
                    if (response.data.data != null) {
                        setGCSkills(response.data.data)
                    }
                } else {
                    setDisplayAlertError(true)
                    setTimeout(() => {
                        setDisplayAlertError(false);
                    }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
                }
            }).catch(err => {
                setDisplayAlertError(true)
                setTimeout(() => {
                    setDisplayAlertError(false);
                }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
            }).finally(() => {
                setLoading(false)
            });
        }
    }, [openGCSkills]);
    // POSkills
    const [openPOSkills, setOpenPOSkills] = useState<boolean>(false);
    const onChangeAccordionPOSkills = () => {
        setLoading(true)
        setOpenPOSkills(true)
        setShowPOSkillsContext(true)
        setLoading(false)
    }
    useEffect(() => {
        if (idBusinessManager != 0) {
            setLoading(true)
            skillsEvaluation.getEaSkillData(request, 11).then(response => {
                if (response.data.success) {
                    if (response.data.data != null) {
                        setPOSkills(response.data.data)
                    }
                } else {
                    setDisplayAlertError(true)
                    setTimeout(() => {
                        setDisplayAlertError(false);
                    }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
                }
            }).catch(err => {
                setDisplayAlertError(true)
                setTimeout(() => {
                    setDisplayAlertError(false);
                }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
            }).finally(() => {
                setLoading(false)
            });
        }
    }, [openPOSkills]);
    // BMSkills
    const [openBMSkills, setOpenBMSkills] = useState<boolean>(false);
    const onChangeAccordionBMSkills = () => {
        setLoading(true)
        setOpenBMSkills(true)
        setShowBMSkillsContext(true)
        setLoading(false)
    }
    useEffect(() => {
        if (idBusinessManager != 0) {
            setLoading(true)
            skillsEvaluation.getEaSkillData(request, 12).then(response => {
                if (response.data.success) {
                    if (response.data.data != null) {
                        setBMSkills(response.data.data)
                    }
                } else {
                    setDisplayAlertError(true)
                    setTimeout(() => {
                        setDisplayAlertError(false);
                    }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
                }
            }).catch(err => {
                setDisplayAlertError(true)
                setTimeout(() => {
                    setDisplayAlertError(false);
                }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
            }).finally(() => {
                setLoading(false)
            });
        }
    }, [openBMSkills]);
    // CMSkills
    const [openCMSkills, setOpenCMSkills] = useState<boolean>(false);
    const onChangeAccordionCMSkills = () => {
        setLoading(true)
        setOpenCMSkills(true)
        setShowCMSkillsContext(true)
        setLoading(false)
    }
    useEffect(() => {
        if (idBusinessManager != 0) {
            setLoading(true)
            skillsEvaluation.getEaSkillData(request, 13).then(response => {
                if (response.data.success) {
                    if (response.data.data != null) {
                        setCMSkills(response.data.data)
                    }
                } else {
                    setDisplayAlertError(true)
                    setTimeout(() => {
                        setDisplayAlertError(false);
                    }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
                }
            }).catch(err => {
                setDisplayAlertError(true)
                setTimeout(() => {
                    setDisplayAlertError(false);
                }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
            }).finally(() => {
                setLoading(false)
            });
        }
    }, [openCMSkills]);
    // EPSkills
    const [openEPSkills, setOpenEPSkills] = useState<boolean>(false);
    const onChangeAccordionEPSkills = () => {
        setLoading(true)
        setOpenEPSkills(true)
        setShowEPSkillsContext(true)
        setLoading(false)
    }
    useEffect(() => {
        if (idBusinessManager != 0) {
            setLoading(true)
            skillsEvaluation.getEaSkillData(request, 14).then(response => {
                if (response.data.success) {
                    if (response.data.data != null) {
                        setEPSkills(response.data.data)
                    }
                } else {
                    setDisplayAlertError(true)
                    setTimeout(() => {
                        setDisplayAlertError(false);
                    }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
                }
            }).catch(err => {
                setDisplayAlertError(true)
                setTimeout(() => {
                    setDisplayAlertError(false);
                }, parseInt(REACT_APP_NOTIFICATION_DURATION) * 1000);
            }).finally(() => {
                setLoading(false)
            });
        }
    }, [openEPSkills]);
    // set data context
    useEffect(() => {
        setBDSkillsDataContext(BDSkills)
    }, [BDSkills]);

    useEffect(() => {
        setSCSkillsDataContext(SCSkills)
    }, [SCSkills]);

    useEffect(() => {
        setRCSkillsDataContext(RCSkills)
    }, [RCSkills]);

    useEffect(() => {
        setMHSkillsDataContext(MHSkills)
    }, [MHSkills]);

    useEffect(() => {
        setGCSkillsDataContext(GCSkills)
    }, [GCSkills]);

    useEffect(() => {
        setPOSkillsDataContext(POSkills)
    }, [POSkills]);

    useEffect(() => {
        setBMSkillsDataContext(BMSkills)
    }, [BMSkills]);

    useEffect(() => {
        setCMSkillsDataContext(CMSkills)
    }, [CMSkills]);

    useEffect(() => {
        setEPSkillsDataContext(EPSkills)
    }, [EPSkills]);

    return (
        <>
            {loading && (
                <>
                    <SuspenseLoader />
                </>
            )}
            <ASMAlert message={t('action.error')} severity="error" open={displayAlertError} />
            <div style={{ backgroundColor: '#ffffff', marginTop: -10 }} >
                <Grid container direction="row" alignItems="stretch" style={{
                    color: 'black',
                    textAlign: 'center',
                    marginTop: 15,
                    marginBottom: 5
                }}>
                    <Grid item xs={1}>
                        <span style={{ fontSize: 15, fontWeight: 500 }}><Trans>noteLabel</Trans></span>
                    </Grid>
                    <Grid item xs={2}>
                        <span style={{ fontSize: 15, fontWeight: 500 }}><Trans>eepBm.evaluation.note0</Trans></span>
                    </Grid>
                    <Grid item xs={1}>
                        <span style={{ fontSize: 15, fontWeight: 500 }}><Trans>eepBm.evaluation.note1</Trans></span>
                    </Grid>
                    <Grid item xs={3}>
                        <span style={{ fontSize: 15, fontWeight: 500 }}><Trans>eepBm.evaluation.note2</Trans></span>
                    </Grid>
                    <Grid item xs={3}>
                        <span style={{ fontSize: 15, fontWeight: 500 }}><Trans>eepBm.evaluation.note3</Trans></span>
                    </Grid>
                    <Grid item xs={2}>
                        <span style={{ fontSize: 15, fontWeight: 500 }}><Trans>eepBm.evaluation.note4</Trans></span>
                    </Grid>
                </Grid>
                <Grid container direction="row" alignItems="stretch" style={{
                    backgroundColor: '#006976',
                    color: '#ffffff',
                    height: 50,
                    textAlign: 'center',
                    fontSize: 12,
                    textTransform: 'uppercase',
                    marginTop: 15,
                    borderRadius: 3,
                    marginBottom: 5
                }}>
                    <Grid item xs={4}>
                        <h3><Trans>eepBm.evaluation.title1</Trans></h3>
                    </Grid>
                    <Grid item xs={1} >
                        <h3 style={{ marginTop: 5, textAlign: 'center' }}><Trans>eepBm.evaluation.title2</Trans></h3>
                    </Grid>
                    <Grid item xs={2} >
                        <h3><Trans>eepBm.evaluation.title3</Trans></h3>
                    </Grid>
                    <Grid item xs={5} >
                        <h3><Trans>eepBm.evaluation.title4</Trans></h3>
                    </Grid>
                </Grid>
                <AccordionEvaluationCompetenceItem
                    title={t('eepBm.evaluation.categories.categ1')}
                    open={openBDSkills}
                    onChange={onChangeAccordionBDSkills}
                    accordionContent={
                        showBDSkills ? <CompetenceBM
                            idBusinessManager={idBusinessManager}
                            skillsData={BDSkills}
                            setData={setBDSkills}
                        /> : <></>
                    }
                />
                <AccordionEvaluationCompetenceItem
                    title={t('eepBm.evaluation.categories.categ2')}
                    open={openSCSkills}
                    onChange={onChangeAccordionSCSkills}
                    accordionContent={
                        showSCSkills ? <CompetenceBM
                            idBusinessManager={idBusinessManager}
                            skillsData={SCSkills}
                            setData={setSCSkills}
                        /> : <></>
                    }
                />
                <AccordionEvaluationCompetenceItem
                    title={t('eepBm.evaluation.categories.categ3')}
                    open={openRCSkills}
                    onChange={onChangeAccordionRCSkills}
                    accordionContent={
                        showRCSkills ? <CompetenceBM
                            idBusinessManager={idBusinessManager}
                            skillsData={RCSkills}
                            setData={setRCSkills}
                        /> : <></>
                    }
                />
                <AccordionEvaluationCompetenceItem
                    title={t('eepBm.evaluation.categories.categ4')}
                    open={openMHSkills}
                    onChange={onChangeAccordionMHSkills}
                    accordionContent={
                        showMHSkills ? <CompetenceBM
                            idBusinessManager={idBusinessManager}
                            skillsData={MHSkills}
                            setData={setMHSkills}
                        /> : <></>
                    }
                />
                <AccordionEvaluationCompetenceItem
                    title={t('eepBm.evaluation.categories.categ5')}
                    open={openGCSkills}
                    onChange={onChangeAccordionGCSkills}
                    accordionContent={
                        showGCSkills ? <CompetenceBM
                            idBusinessManager={idBusinessManager}
                            skillsData={GCSkills}
                            setData={setGCSkills}
                        /> : <></>
                    }
                />
                <AccordionEvaluationCompetenceItem
                    title={t('eepBm.evaluation.categories.categ6')}
                    open={openPOSkills}
                    onChange={onChangeAccordionPOSkills}
                    accordionContent={
                        showPOSkills ? <CompetenceBM
                            idBusinessManager={idBusinessManager}
                            skillsData={POSkills}
                            setData={setPOSkills}
                        /> : <></>
                    }
                />
                <AccordionEvaluationCompetenceItem
                    title={t('eepBm.evaluation.categories.categ7')}
                    open={openBMSkills}
                    onChange={onChangeAccordionBMSkills}
                    accordionContent={
                        showBMSkills ? <CompetenceBM
                            idBusinessManager={idBusinessManager}
                            skillsData={BMSkills}
                            setData={setBMSkills}
                        /> : <></>
                    }
                />
                <AccordionEvaluationCompetenceItem
                    title={t('eepBm.evaluation.categories.categ8')}
                    open={openCMSkills}
                    onChange={onChangeAccordionCMSkills}
                    accordionContent={
                        showCMSkills ? <CompetenceBM
                            idBusinessManager={idBusinessManager}
                            skillsData={CMSkills}
                            setData={setCMSkills}
                        /> : <></>
                    }
                />
                <AccordionEvaluationCompetenceItem
                    title={t('eepBm.evaluation.categories.categ9')}
                    open={openEPSkills}
                    onChange={onChangeAccordionEPSkills}
                    accordionContent={
                        showEPSkills ? <CompetenceBM
                            idBusinessManager={idBusinessManager}
                            skillsData={EPSkills}
                            setData={setEPSkills}
                        /> : <></>
                    }
                />
            </div>
        </>
    );
}

export default EvaluationCompetenceBM;